// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

export interface LimitsContextProps {
  mintLimit: number;
  burnLimit: number;
  setMintLimit: (v: number) => void;
  setBurnLimit: (v: number) => void;
}

export const defaultMintLimit = 10_000_000;
export const defaultBurnLimit = 10_000_000;

export const LimitsContext = React.createContext<LimitsContextProps>({
  mintLimit: defaultMintLimit,
  burnLimit: defaultBurnLimit,
  setMintLimit: () => {
    throw new Error(
      'setMintLimit called outside of LimitsProvider. ' +
        'Ensure the component is wrapped with LimitsProvider.',
    );
  },
  setBurnLimit: () => {
    throw new Error(
      'setBurnLimit called outside of LimitsProvider. ' +
        'Ensure the component is wrapped with LimitsProvider.',
    );
  },
});

export const useLimits = () => {
  return React.useContext(LimitsContext);
};
